import { Component } from '@angular/core';
import { StateService } from './services/state.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  constructor(public state: StateService) {}

  logout() {
    this.state.logout().subscribe();
  }
}
